import React from 'react';
import { PlayBadge, PLAY_BADGE_SIZE } from '../../../PlayBadge/PlayBadge';
import { StyledLiveBadge } from './LiveBadge.styles';

const LiveBadge = ({ item }) => {
    return (
        <StyledLiveBadge>
            {item.badge && (
                <PlayBadge
                    text={item?.badge?.text}
                    theme={item?.badge?.type}
                    accessibilityText={item?.badge?.altText}
                    overlay
                    size={PLAY_BADGE_SIZE.LARGE}
                />
            )}
        </StyledLiveBadge>
    );
};

export default LiveBadge;
